// extracted by mini-css-extract-plugin
export default {"deck":"styles_deck__UHf59 unselectable_unselectable__CvM2m","card":"styles_card__SNIPf unselectable_unselectable__CvM2m"};